export const ScheduleMonthConstants = {
    cardWidth: 260,
    cardHeight: 160,
    maxColumns: 7,
    maxRows: 6,
}